import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { SectionHeading } from "./SectionHeading";

export default function Testimonials({ items = [] }) {
    return (
        <section
            data-testid="home-testimonials"
            className="relative py-20 md:py-24 border-t border-white/5"
        >
            <div className="max-w-[1400px] mx-auto px-5 md:px-8 lg:px-10">
                <SectionHeading
                    eyebrow="In their words"
                    title="The leaders we partner with."
                    subtitle="A handful of moments captured from engagements we're proud of."
                />

                <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-5">
                    {items.map((t, i) => (
                        <motion.figure
                            key={t.id}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.55, delay: i * 0.06 }}
                            className={`group relative overflow-hidden glass rounded-3xl border border-white/5 p-8 md:p-10 brand-border-hover ${i % 3 === 1 ? "md:translate-y-6" : ""}`}
                            data-testid={`testimonial-${t.id}`}
                        >
                            <Quote className="h-6 w-6 text-brand-green opacity-60" />
                            <blockquote className="mt-5 font-display text-xl md:text-[24px] leading-snug tracking-tight text-white">
                                "{t.quote}"
                            </blockquote>
                            <figcaption className="mt-7 flex items-center gap-3">
                                <div className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-brand-linear text-white font-display text-sm">
                                    {t.name.split(" ").map((n) => n[0]).slice(0, 2).join("")}
                                </div>
                                <div>
                                    <div className="text-[14px] text-white">{t.name}</div>
                                    <div className="text-[12px] text-zinc-500">
                                        {t.role} · {t.org}
                                    </div>
                                </div>
                            </figcaption>
                        </motion.figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
